import { action, observable, makeObservable } from 'mobx'

export default class PreloaderStore {
    private _mainPreloaderIsOpen: boolean

    private _transparentPreloaderIsOpen: boolean
    constructor() {
        makeObservable<PreloaderStore, '_mainPreloaderIsOpen' | '_transparentPreloaderIsOpen'>(this, {
            _mainPreloaderIsOpen: observable,
            _transparentPreloaderIsOpen: observable,
            openMainPreloader: action,
            openTransparentPreloader: action,
        })
        this._mainPreloaderIsOpen = false
        this._transparentPreloaderIsOpen = false
    }

    get mainPreloaderIsOpen(): boolean {
        return this._mainPreloaderIsOpen
    }

    get transparentPreloaderIsOpen(): boolean {
        return this._transparentPreloaderIsOpen
    }

    openMainPreloader(isOpen: boolean): void {
        this._mainPreloaderIsOpen = isOpen
    }

    openTransparentPreloader(isOpen: boolean): void {
        this._transparentPreloaderIsOpen = isOpen
    }
}
